import { DEFAULT_PRECISION_MONEY } from 'utils/constants/index'
import moment from 'moment'
import store from 'redux-store/store'
import { divide, times, minus } from 'number-precision'

export const formatDate = (originalDateString) => {
  const date = new Date(originalDateString)

  // const months = [
  //   'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  //   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  // ]
  const day = date.getDate()
  const monthIndex = date.getMonth() + 1
  const year = date.getFullYear()
  const formattedDate = `${day}/${monthIndex}/${year}`
  return formattedDate
}

export const formatTime = (originalDateString) => {
  const date = new Date(originalDateString)

  const hours = date.getHours()
  const minutes = date.getMinutes()

  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12 // Convert 0 to 12 for 12 AM

  const formattedTime = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`

  return formattedTime
}

export const formatTime24Hour = (originalDateString) => {
  const date = new Date(originalDateString)

  const hours = date.getHours()
  const minutes = date.getMinutes()

  // Format time in 24-hour format
  const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`

  return formattedTime
}

/**
 * Parses payload object from jwt
 * @param {string} token
 * @returns {Object}
 */
export const getPayloadFromToken = (token) => {
  if (token) {
    return JSON.parse(atob(token.split('.')[1]))
  }
}

/**
 * Generate a random card number between [1,52]
 * @returns {number}
 */
export const randomCardGenerate = () => {
  return Math.floor(Math.random() * 52) + 1
}

/**
 *
 * @param {Number} n
 * @returns {Number} factorial of n
 */
export const factorial = n => {
  let fact = 1
  for (let i = 2; i <= n; i++) {
    fact *= i
  }
  return fact
}

/**
 *
 * @param {Number} n
 * @param {Number} r
 * @returns {Number} combination of n over r
 */
export const combination = (n, r) => {
  if (r > n) {
    return 0
  }
  return factorial(n) / (factorial(r) * factorial(n - r))
}

/**
 *
 * @param {Number} numberOfCoins
 * @param {Number} minimumChosenOutcome
 * @returns {Number} probability of minimum X number of favorable outcomes
 */
export const getCoinOutcomeProbability = (numberOfCoins, minimumChosenOutcome) => {
  const n = numberOfCoins - minimumChosenOutcome
  let sum = 0
  for (let i = 0; i <= n; i++) {
    sum += combination(numberOfCoins, i)
  }
  return sum / 2 ** numberOfCoins
}

/**
 * To calculate flip coin potential win
 * @param {number} betAmount
 * @param {number} numberOfCoins
 * @param {number} minimumChosenOutcome
 * @param {number} houseEdge
 * @returns {number}
 */
export const getFlipCoinPotentialWin = (betAmount, numberOfCoins, minimumChosenOutcome, houseEdge) => {
  const probability = getCoinOutcomeProbability(numberOfCoins, minimumChosenOutcome)
  const odds = (1 / probability) * (1 - houseEdge / 100)
  return +Number((betAmount * odds)).toFixed(2)
}

/**
 *
 * @param {string} s
 * @returns {Number} count of one
 */
export const countOnes = (s) => {
  let count = 0
  for (const i of s) {
    if (i === '1') {
      count++
    }
  }
  return count
}

/**
 *
 * @param  {...Array} a Specify arrays to do cartesian product
 * @returns {Array.<Array.<number[]>>} Returns the cartesian product of given arrays
 */
export const cartesianProductOfArrays = (...a) => a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())))

export const generateClientSeed = () => {
  const availableChars = '0123456789abcdef'
  let seed = ''
  for (let i = 0; i < 32; i++) {
    seed += availableChars[Math.floor(Math.random() * availableChars.length)]
  }
  return seed
}

/**
 *
 * @param {number} value
 * @param {number} precision
 * @returns {number | string} Returns precision value for specified decimal places
 */
export const getPrecision = (value, precision = DEFAULT_PRECISION_MONEY) => {
  const precisionDivide = Math.pow(10, precision)
  const result = divide(Math.round(times(value, precisionDivide)), precisionDivide)
  return result || 0
}

/**
 *
 * @param {number} x
 * @returns {string} valid million based comma value in string
 */
export const numberWithCommas = (x) => {
  if (x === null || x === undefined || Number(x) === Number.isNaN) {
    return ''
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const enforceTwoDecimalPlaces = (e) => {
  const value = e.target.value
  const decimalIndex = value.indexOf('.')

  if (decimalIndex !== -1 && value.length - decimalIndex > 3) {
    e.target.value = value.slice(0, decimalIndex + 3) // Limit to two decimal places
  }
}

export function formatToTwoDecimalPlaces (value) {
  if (value === '') return value // if value is empty return value

  const num = parseFloat(value) // Ensure the input is a number
  if (isNaN(num)) {
    return 0 // Return 0 if input is not a valid number
  }
  // Multiply by 100, round to remove extra decimal places, and divide back by 100
  // return Math.round(num * 100) / 100
  return Number(num.toFixed(2))
}

export const format24HourTime = (inputDate) => {
  const formattedTime = inputDate ? moment(new Date(inputDate)).format('HH:mm:ss') : ''
  return formattedTime
}
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const getNumToStringPrecision = (input = 0, precision, removeTrailingZeros = true) => {

  precision = precision ?? store?.getState()?.gameSetting?.currencyPrecision
  if (typeof input === 'number') {
    const factor = Math.pow(10, precision)
    input = divide(Math.trunc(times(input, factor)), factor)
    input = input.toFixed(precision)
  }

  const str = String(input)

  return str

  // //This regex checks whether the entire string consists only of 0 and/or . characters, and nothing else
  // if (/^[0.]+$/.test(str)) {
  //   // Only zeros and decimal
  //   return str
  // }

  // if (removeTrailingZeros) {
  //   return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '') // Removes only trailing zeros after decimal
  // } else {
  //   return str
  // }
}

export const calculateOdds = ({ minOdds = 0, maxOdds = 0, houseEdge = 0, odds = 0, precision = 2 }) => {
  const deductHouseEdge = minus(1, divide(houseEdge, 100))
  let newOdds = times(odds, deductHouseEdge)
  if (maxOdds) {
    newOdds = Math.min(maxOdds, newOdds) // max odd capping
  }
  if (minOdds) {
    newOdds = Math.max(minOdds, newOdds) // min odd capping
  }
  newOdds = getPrecision(newOdds, precision)
  return newOdds
}